<app-card-content [icon]="'pi pi-search'" [title]="'Localizar Solicitacao'" [subtitle]="'Historico de solicitacoes'">
    <div card-header class="localizar-card-acoes">
        @if (solicitacaoSelecionada && podeExibirAcoes()) {
            <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoesMenu" [iconColumns]="1"></app-botao-acoes>
        }
    </div>

    <div class="consulta-form">
        <div class="tipo-pesquisa-bloco">
            <div class="field opcoes-pesquisa">
                <span class="campo-label">Tipo de busca</span>
                <div class="tipo-pesquisa-grid">
                    <label class="tipo-pesquisa-card" [class.selecionado]="tipoPesquisa === 'CPF'" (click)="alterarTipoPesquisa('CPF')">
                        <div class="tipo-pesquisa-texto">
                            <strong>CPF</strong>
                            <small>Busca todas as solicitações vinculadas ao CPF informado.</small>
                        </div>
                        <p-radiobutton [ngModel]="tipoPesquisa" (ngModelChange)="alterarTipoPesquisa($event)" inputId="tipo-pesquisa-cpf" name="tipoPesquisaSolicitacao" value="CPF"></p-radiobutton>
                    </label>
                    <label class="tipo-pesquisa-card" [class.selecionado]="tipoPesquisa === 'ID'" (click)="alterarTipoPesquisa('ID')">
                        <div class="tipo-pesquisa-texto">
                            <strong>ID da solicitação</strong>
                            <small>Busca direta de uma solicitação específica pelo identificador.</small>
                        </div>
                        <p-radiobutton [ngModel]="tipoPesquisa" (ngModelChange)="alterarTipoPesquisa($event)" inputId="tipo-pesquisa-id" name="tipoPesquisaSolicitacao" value="ID"></p-radiobutton>
                    </label>
                </div>
            </div>
        </div>

        <div class="consulta-campos-linha">
            <div class="field">
                @if (tipoPesquisa === 'CPF') {
                    <label for="cpf-pesquisa">CPF</label>
                    <input id="cpf-pesquisa" pInputText type="text" maxlength="14" [(ngModel)]="cpf" (keyup.enter)="pesquisar()" />
                } @else {
                    <label for="id-solicitacao-pesquisa">ID da solicitação</label>
                    <input id="id-solicitacao-pesquisa" pInputText type="text" maxlength="12" [(ngModel)]="idSolicitacao" (keyup.enter)="pesquisar()" />
                }
            </div>

            <div class="acoes">
                <button pButton type="button" icon="pi pi-search" label="Pesquisar" [disabled]="carregando()" (click)="pesquisar()"></button>
                <button pButton type="button" icon="pi pi-eraser" class="p-button-text" label="Limpar" [disabled]="carregando()" (click)="limpar()"></button>
            </div>
        </div>
    </div>

    @if (carregando()) {
        <div class="feedback">Consultando solicitações...</div>
    } @else if (erroConsulta) {
        <div class="feedback erro">{{ erroConsulta }}</div>
    } @else if (pesquisado && !resultados.length) {
        <div class="feedback">{{ obterMensagemSemResultado() }}</div>
    } @else if (resultados.length) {
        <p-table [value]="resultados" dataKey="idSolicitacao" selectionMode="single" [selection]="solicitacaoSelecionada" (selectionChange)="onSelecaoAlterada($event)" responsiveLayout="scroll" styleClass="consulta-table">
            <ng-template pTemplate="header">
                <tr>
                    <th>ID</th>
                    <th>Nome Médico</th>
                    <th>CRM</th>
                    <th>UF Origem</th>
                    <th>UF Destino</th>
                    <th>Tipo</th>
                    <th>Status</th>
                    <th>Data Solicitação</th>
                    <th>Data Validade</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr [pSelectableRow]="item" class="cursor-pointer select-none">
                    <td><p-badge [value]="item.idSolicitacao ?? '-'" severity="secondary"></p-badge></td>
                    <td>{{ item.nomeMedico || '-' }}</td>
                    <td>{{ item.crm || '-' }}</td>
                    <td>
                        <div class="uf-cell">
                            @if (obterBandeiraUf(item.ufOrigem); as bandeiraUfOrigem) {
                                <img [src]="bandeiraUfOrigem" [alt]="formatarUf(item.ufOrigem)" class="uf-flag" />
                            }
                            <span>{{ formatarUf(item.ufOrigem) }}</span>
                        </div>
                    </td>
                    <td>
                        <div class="uf-cell">
                            @if (obterBandeiraUf(item.ufDestino); as bandeiraUfDestino) {
                                <img [src]="bandeiraUfDestino" [alt]="formatarUf(item.ufDestino)" class="uf-flag" />
                            }
                            <span>{{ formatarUf(item.ufDestino) }}</span>
                        </div>
                    </td>
                    <td><p-tag [value]="obterTipoSolicitacao(item)" [severity]="obterSeveridadeTipo(item)" styleClass="tipo-badge"></p-tag></td>
                    <td>{{ obterStatus(item) }}</td>
                    <td>{{ formatarData(item.dataSolicitacao) }}</td>
                    <td><p-badge [value]="formatarData(item.dataValidade)" [severity]="severidadeDataValidade(item.dataValidade)"></p-badge></td>
                </tr>
            </ng-template>
        </p-table>
    }
</app-card-content>

<p-dialog appDialogoPadrao="pi pi-check-square" descricao="Endereço para onde a correspondência será enviada." [(visible)]="dialogSelecaoVisivel" [style]="{ width: '500px' }" header="Selecionar Correspondência" (onHide)="cancelarDialogSelecao()">
    <div class="dialog-selecao-corpo">
        @if (dialogSelecaoCarregando()) {
            <div class="dialog-selecao-feedback">Verificando correspondências disponíveis...</div>
        } @else if (dialogSelecaoErro) {
            <div class="dialog-selecao-feedback erro">{{ dialogSelecaoErro }}</div>
        } @else {
            <p class="dialog-selecao-descricao">Selecione qual correspondência deseja visualizar para a Solicitação {{ solicitacaoSelecionada?.idSolicitacao }}.</p>

            <div class="relatorio-selecao-grid">
                @for (opcao of opcoesDisponiveis; track opcao.tipo) {
                    <div class="relatorio-selecao-card" [class.selecionado]="relatorioSelecionadoTemp === opcao.tipo" (click)="relatorioSelecionadoTemp = opcao.tipo">
                        <div class="relatorio-selecao-icone">
                            <i [class]="opcao.icone"></i>
                        </div>
                        <div class="relatorio-selecao-texto">
                            <strong>{{ opcao.titulo }}</strong>
                            <small>{{ opcao.descricao }}</small>
                        </div>
                        <p-radiobutton name="relatorioSelecao" [value]="opcao.tipo" [(ngModel)]="relatorioSelecionadoTemp" [inputId]="'relatorio-' + opcao.tipo"></p-radiobutton>
                    </div>
                }
            </div>
        }

        <div class="dialog-selecao-acoes">
            <button pButton type="button" icon="pi pi-times" label="Cancelar" class="p-button-text" (click)="cancelarDialogSelecao()"></button>
            @if (!dialogSelecaoCarregando() && !dialogSelecaoErro) {
                <button pButton type="button" icon="pi pi-eye" label="Visualizar" (click)="confirmarSelecaoRelatorio()"></button>
            }
        </div>
    </div>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Transferência de inscrição entre UFs."
    [(visible)]="dialogCorrespondenciaVisivel"
    [maximizable]="true"
    [style]="{ width: '90vw', maxWidth: '1100px' }"
    [contentStyle]="{ 'max-height': '75vh', overflow: 'auto' }"
    [header]="dialogTitulo"
    (onHide)="fecharDialogCorrespondencia()"
>
    @if (dialogCarregando()) {
        <div class="correspondencia-feedback">Carregando correspondências...</div>
    } @else if (dialogErro) {
        <div class="correspondencia-feedback erro">{{ dialogErro }}</div>
    } @else {
        <div class="correspondencia-lista">
            @if (certificadoPdfUrl) {
                <section class="correspondencia-item">
                    <h3>Certificado de Regularidade</h3>
                    <iframe [src]="certificadoPdfUrl" class="certificado-pdf-iframe"></iframe>
                </section>
            }
            @if (oficioRepudioPdfUrl) {
                <section class="correspondencia-item">
                    <h3>Ofício de Repúdio</h3>
                    <iframe [src]="oficioRepudioPdfUrl" class="certificado-pdf-iframe"></iframe>
                </section>
            }
            @for (correspondencia of correspondenciasHtml; track correspondencia.titulo) {
                <section class="correspondencia-item">
                    <h3>{{ correspondencia.titulo }}</h3>
                    <div class="correspondencia-html" [innerHTML]="correspondencia.html"></div>
                </section>
            }
        </div>
    }
</p-dialog>
